module.exports = __webpack_public_path__ + "onboardingImage.4a246435ce81d94a29749882ee40fba2.hashedasset.svg";